import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { noop, isNil } from 'lodash-es';
import { useIMask } from 'react-imask';
import { InputComponent } from 'site-modules/lease-deals/components/input/input';

export const PriceInput = ({ value, onChange, min, max, onBlur = noop, ...props }) => {
  const maskOptions = useMemo(
    () => ({
      mask: [
        { mask: /^$/ },
        {
          mask: Number,
          scale: 0,
          thousandsSeparator: ',',
          min,
          max,
          normalizeZeros: false,
          padFractionalZeros: false,
          signed: false,
        },
      ],
    }),
    [min, max]
  );

  const { ref, maskRef } = useIMask(maskOptions, {
    onAccept: (val, mask, e) => {
      if (!e) return;

      if (['insertText', 'insertFromPaste'].includes(e.inputType) && /^(0\d+)|(0[,.]\d+)/.test(val)) {
        // eslint-disable-next-line no-param-reassign
        mask.value = mask.unmaskedValue;
        mask.updateValue();
      }

      onChange(mask.unmaskedValue, e);
    },
  });

  useEffect(() => {
    if (!maskRef.current) return;

    const nextValue = isNil(value) ? '' : String(value);

    if (maskRef.current.unmaskedValue !== nextValue) {
      maskRef.current.unmaskedValue = nextValue;
      maskRef.current.updateValue();
    }
  }, [maskRef, value]);

  const handleBlur = useCallback(
    e => {
      const currentVal = maskRef.current.value;
      if (/^0+$/.test(currentVal) && currentVal.length > 1) {
        maskRef.current.value = '0';
        maskRef.current.updateValue();
      }

      onBlur(e);
    },
    [maskRef, onBlur]
  );

  return <InputComponent innerRef={ref} onBlur={handleBlur} {...props} />;
};

PriceInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onBlur: PropTypes.func,
};
